<template>
    <b-row v-if="listaModalidades && contrato !== undefined" class="ml-1 d-flex align-items-start">
        <b-col cols="12" md="6">
            <b-row class="d-flex align-items-start">
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Número da Licitação" v-slot="defaultState">
                        <b-form-input id="input-numero" v-model="contrato.NrLicitacao" @change="procedimentoOrigemAtualizado" :state="defaultState.state"
                            rules="max:8">
                        </b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col md="2" class="d-sm-none d-md-flex justify-content-center align-items-center mt-4 pt-2">
                    <span class="h2">/</span>
                </b-col>
                <b-col cols="12" md="4">
                    <default-form-validation-provider label="Ano da Licitação" v-slot="defaultState">
                        <b-form-input id="input-ano" v-model="contrato.NrAnoLicitacao" @change="procedimentoOrigemAtualizado" :state="defaultState.state"
                            type="number"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Modalidade da Licitação" v-slot="defaultState">
                        <b-form-select id="select-modalidade" v-model="contrato.IdModalidade" @change="procedimentoOrigemAtualizado" :options="listaModalidades"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Unidade Federativa" v-slot="defaultState">
                        <b-form-select id="select-uf" v-model="contrato.SgUf" @change="procedimentoOrigemAtualizado" :options="listaUF"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="5">
                    <default-form-validation-provider label="Município" rules="required|max:120"
                        v-slot="defState">
                        <b-form-input v-model="contrato.NmMunicipio" @change="procedimentoOrigemAtualizado" :state="defState.state"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12">
                    <default-form-validation-provider label="CNPJ Órgão Responsável" rules="required|min:14|max:14|numeric"
                        v-slot="defState">
                        <b-form-input v-model="contrato.NrCnpjOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defState.state" />
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="5">
                    <default-form-validation-provider label="Órgão Responsável" rules="required|max:120"
                        v-slot="defState">
                        <b-form-input v-model="contrato.NmOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defState.state"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import ldiService from '@/services/licitacoes/ldiService'

const CompProps = Vue.extend({
    name: 'EditarProcedimentoOrigemDispensaAtaRegistroPreco',
    components: { DefaultFormValidationProvider },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class EditarProcedimentoOrigemAtaRegistroPreco extends mixins(UtilsTS, CompProps) {
    contrato: Contrato = new Contrato()
    listaModalidades: any[] | null = null
    listaUF = [
        { value: null, text: 'SELECIONE' },
        { value: 'AC', text: 'Acre' },
        { value: 'AL', text: 'Alagoas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Goiás' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PR', text: 'Paraná' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'TO', text: 'Tocantins' }
    ]

    async mounted() {
        try {
            this.contrato = this.ctr
            store.blockScreen = true
            const responseModalidades = await ldiService.listarModalidades('');
            this.listaModalidades = [{ value: null, text: 'SELECIONE' }, ...responseModalidades.data.map(m => ({ value: m.IdModalidade, text: m.DeModalidade }))]
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarProcedimentoOrigemContratoCentralizado', e)
        } finally {
            store.blockScreen = false
        }
    }

    procedimentoOrigemAtualizado() {
        this.$emit('input', this.contrato)
    }
}


</script>

<style scoped>
    :deep(svg) {
        padding-bottom: 0.75em;
    }
</style>